// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const InStock: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13">
            <path
                fill="#00A65A"
                d="M6 .5a6 6 0 1 0 0 12 6 6 0 1 0 0-12Zm2.714 4.964-3 3a.653.653 0 0 1-.928 0l-1.5-1.5a.657.657 0 0 1 .929-.929L5.25 7.073l2.536-2.536a.657.657 0 0 1 .928.928Z"
                opacity=".66"
            />
        </svg>
    );
};

export default React.memo(InStock);
